// extracted by mini-css-extract-plugin
export var content = "_de-3";
export var list = "_de-4";
export var settingsContent = "_de-7";
export var settingsPanel = "_de-8";
export var state = "_de-6";
export var triggerBadge = "_de-2";
export var triggerButton = "_de-1";
export var triggerShell = "_de-0";
export var unreadDot = "_de-5";